export enum AppointmentContainerCodes {
  BASIC_INFO = 'appointment_detail_header',
  MEETING_OVERVIEW = 'appointment_detail_meeting_overview',
  PAGE_RATING = 'appointment_detail_page_rating',
  MEETING_DETAIL = 'appointment_detail_meeting_detail',
  TOPIC = 'appointment_detail_related_topics',
  TAGS = 'appointment_detail_tags',
}
